import React from 'react'
import { Link } from 'react-router-dom'
import Logo from "../assets/logo.jpg"
const Navbar = () => {
  return (
    <div className='navbar_container'>

      <div className="nav_menu">
        <div className="nav_logo">
          <Link to="/"><img src={Logo} alt='Nav-logo'/> </Link>
        </div>
      </div>
    </div>
  )
}

export default Navbar